var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		_vm.$style['app-notched-outline-idle'],
		{
			[_vm.$style['app-notched-outline-idle--notched']]: _vm.isFloated,
			[_vm.$style['app-notched-outline-idle--hidden']]: _vm.isFocused
		}
	]})
}
var staticRenderFns = []

export { render, staticRenderFns }